module.exports = __webpack_public_path__ + "static/img/chain-capacity.a050f609.png";